import(/* webpackMode: "eager", webpackExports: ["V2CoverEditorScreen"] */ "/app/apps/platform-web/components/v2/screens/V2CoverEditorScreen.tsx");
